// extracted by mini-css-extract-plugin
export var aircallIframe = "_e0-3";
export var fabContainer = "_e0-5";
export var fabRinging = "_e0-6";
export var loadingOverlay = "_e0-4";
export var pulse = "_e0-7";
export var widgetContent = "_e0-2";
export var widgetPanel = "_e0-0";
export var widgetPanelExpanded = "_e0-1";